export function deepCopy<T extends any | []>(element: T): T {
    try {
        if (window != null && 'structuredClone' in window) {
            return structuredClone(element);
        }

        throw new Error();
    } catch (_) {
        return JSON.parse(JSON.stringify(element));
    }
}
